import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgTelegramAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM16.5732 11.8119C15.017 12.4592 11.9067 13.7989 7.24236 15.8311C6.48495 16.1323 6.08818 16.427 6.05206 16.7151C5.99102 17.202 6.60079 17.3937 7.43114 17.6548C7.54408 17.6904 7.66111 17.7272 7.78109 17.7662C8.59802 18.0317 9.69694 18.3424 10.2682 18.3547C10.7864 18.3659 11.3648 18.1523 12.0034 17.7138C16.3614 14.772 18.611 13.2851 18.7522 13.253C18.8519 13.2304 18.99 13.202 19.0835 13.2851C19.1771 13.3683 19.1679 13.5258 19.158 13.568C19.0976 13.8255 16.704 16.0508 15.4653 17.2024C15.0792 17.5614 14.8053 17.816 14.7493 17.8742C14.6238 18.0045 14.496 18.1277 14.3731 18.2461C13.6142 18.9778 13.045 19.5264 14.4047 20.4224C15.058 20.853 15.5808 21.209 16.1024 21.5642C16.6721 21.9521 17.2402 22.339 17.9753 22.8209C18.1626 22.9437 18.3415 23.0712 18.5157 23.1954C19.1786 23.668 19.7742 24.0926 20.5099 24.0249C20.9375 23.9855 21.3791 23.5835 21.6034 22.3845C22.1335 19.5509 23.1753 13.4113 23.4161 10.8813C23.4372 10.6596 23.4107 10.376 23.3894 10.2514C23.3681 10.1269 23.3235 9.94948 23.1617 9.81813C22.97 9.66258 22.674 9.62978 22.5417 9.63211C21.9399 9.64271 21.0166 9.96376 16.5732 11.8119Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTelegramAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
